import React from "react";

const Impressum = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 text-white bg-black mt-8">
      <h1 className="text-4xl font-bold mb-10 text-white">Impressum</h1>

      <div className="bg-gray-900 p-8 rounded-xl shadow-xl border border-gray-700 space-y-10">
        {/* Verantwortlich */}
        <div>
          <h2 className="text-2xl font-semibold border-b pb-2 border-gray-700 mb-4">
            VERANTWORTLICH FÜR DEN INHALT:
          </h2>
          <p className="leading-relaxed text-gray-200">
            <strong>Oase Salon Massage Kosmetik Fußpflege</strong>
            <br />
            Schäffergasse 1<br />
            1040 Wien, Österreich
          </p>
        </div>

        {/* Gewerbliche Registrierungen */}
        <div>
          <h2 className="text-2xl font-semibold border-b pb-2 border-gray-700 mb-4">
            Gewerbliche Registrierungen
          </h2>

          {/* Kosmetik */}
          <section className="bg-gray-800 p-6 rounded-lg border border-gray-700 mb-6">
            <h3 className="text-lg font-medium mb-4 text-white">
              Kosmetik (Schönheitspflege)
            </h3>
            <dl className="space-y-2 text-gray-200">
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">Behörde:</dt>
                <dd>Magistrat der Stadt Wien (GISA-Zahl: 34673157)</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">
                  Gewerbeberechtigung:
                </dt>
                <dd>Entstehung: 15.03.2022</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">Anschrift:</dt>
                <dd>Schäffergasse 1, 1040 Wien</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">GLN:</dt>
                <dd>9110026141883</dd>
              </div>
            </dl>
          </section>

          {/* Massage */}
          <section className="bg-gray-800 p-6 rounded-lg border border-gray-700 mb-6">
            <h3 className="text-lg font-medium mb-4 text-white">
              Massage (Fußreflexzonenmassage)
            </h3>
            <dl className="space-y-2 text-gray-200">
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">Behörde:</dt>
                <dd>Magistrat der Stadt Wien (GISA-Zahl: 34673171)</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">
                  Gewerbeberechtigung:
                </dt>
                <dd>Entstehung: 15.03.2022</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">Anschrift:</dt>
                <dd>Schäffergasse 1, 1040 Wien</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">GLN:</dt>
                <dd>9110026141883</dd>
              </div>
            </dl>
          </section>

          {/* Fußpflege */}
          <section className="bg-gray-800 p-6 rounded-lg border border-gray-700">
            <h3 className="text-lg font-medium mb-4 text-white">Fußpflege</h3>
            <dl className="space-y-2 text-gray-200">
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">Behörde:</dt>
                <dd>Magistrat der Stadt Wien (GISA-Zahl: 34673140)</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">
                  Gewerbeberechtigung:
                </dt>
                <dd>Entstehung: 15.03.2022</dd>
              </div>
              <div className="flex gap-2">
                <dt className="font-semibold text-gray-200">Anschrift:</dt>
                <dd>Schäffergasse 1, 1040 Wien</dd>
              </div>
            </dl>
          </section>
        </div>

        {/* Geschäftsführung */}
        <div>
          <h2 className="text-2xl font-semibold border-b pb-2 border-gray-700 mb-4">
            Geschäftsführung
          </h2>
          <dl className="space-y-2 text-gray-200">
            <div className="flex gap-2">
              <dt className="font-semibold text-gray-200">Name:</dt>
              <dd>Ruixia Forabosco</dd>
            </div>
            <div className="flex gap-2">
              <dt className="font-semibold text-gray-200">Geburtsdatum:</dt>
              <dd>17.09.1974</dd>
            </div>
            <div className="flex gap-2">
              <dt className="font-semibold text-gray-200">Bestellung am:</dt>
              <dd>15.03.2022</dd>
            </div>
          </dl>
        </div>

        {/* Kontakt */}
        <div>
          <h2 className="text-2xl font-semibold border-b pb-2 border-gray-700 mb-4">
            Kontakt
          </h2>
          <p className="text-gray-200">
            Tel.:{" "}
            <a
              href="tel:+4366499099070"
              className="text-blue-400 underline underline-offset-2 hover:text-blue-600"
            >
              +43 664 990 99070
            </a>
            <br />
            UID: ATU73892727
          </p>
        </div>

      </div>
    </div>
  );
};

export default Impressum;
